import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LoginPageComponent } from './pages/login/login.page';
import { AuthWrapperComponent } from './pages/auth-wrapper/index';
import { AuthGuard } from './guards/index';
import { AuthService } from '../shared/services/index';
import { AuthRoutingModule } from './auth.routing';
import { SharedModule } from '../shared.module';

@NgModule({
  declarations: [LoginPageComponent, AuthWrapperComponent],
  imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule, AuthRoutingModule],
  providers: [AuthGuard, AuthService]
})
export class AuthModule {}
